module.exports = __webpack_public_path__ + "static/media/toystorecommunity.c1d7247d.svg";